<template>
<div>
  <navigation-bar></navigation-bar>
  <div id="app" class="bgc">
    <div class="content-view">
    <router-view :key="$route.fullPath"/>
    </div>
  </div>
</div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar';

export default {
  name: 'App',
  components: {
    NavigationBar,
  },
};
</script>
<style lang="scss">
@import "../node_modules/bulma/bulma.sass";
@import url('https://fonts.googleapis.com/css?family=Lora|Merriweather');
html {
  background-color: bisque;
}
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.content-view {
  padding: 1rem;
}
.bgc {
  background-color: bisque;
}
body {
  // font-family: 'Lora', serif;
font-family: 'Merriweather', serif;


}
h1,h2,h3,h4,h5 {
  font-family: 'Lora', serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue